<script>
    // Importa el componente OperadorView desde su respectiva ubicación
    import OperadorView from "../../viewsERP/Operador.svelte";
</script>

<div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
        <OperadorView />
    </div>
</div>
